import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "custom-container my-3" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning alert-dismissible fade show shadow-sm",
  role: "alert"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Add Departments!", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "alert",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_5 = {
  key: 1,
  class: "alert alert-warning alert-dismissible fade show shadow-sm",
  role: "alert"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Add Employees!", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "alert",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_8 = {
  key: 2,
  class: "alert alert-warning alert-dismissible fade show shadow-sm",
  role: "alert"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Add another Admin!", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "alert",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_11 = {
  key: 3,
  class: "alert alert-warning alert-dismissible fade show shadow-sm",
  role: "alert"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "Shifts & Rosters!", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "alert",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "card bg-light mb-3 shadow-sm" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body border-0" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "h4" }, "Dashboard")
  ])
], -1)
const _hoisted_15 = { class: "row mb-2" }
const _hoisted_16 = { class: "col-md-6 col-lg-3 col-sm-6 mb-3 mb-lg-0" }
const _hoisted_17 = { class: "card text-white bg-info shadow-sm" }
const _hoisted_18 = { class: "card-body mx-auto text-center" }
const _hoisted_19 = { class: "icon-dashboard-wrapper bg-light d-flex justify-content-center align-items-center mx-auto" }
const _hoisted_20 = { class: "h5 mt-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, null, -1)
const _hoisted_22 = { class: "col-md-6 col-lg-3 col-sm-6 mb-3 mb-lg-0" }
const _hoisted_23 = { class: "card text-white bg-success shadow-sm" }
const _hoisted_24 = { class: "card-body mx-auto text-center" }
const _hoisted_25 = { class: "icon-dashboard-wrapper bg-light d-flex justify-content-center align-items-center mx-auto" }
const _hoisted_26 = { class: "h5 mt-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, null, -1)
const _hoisted_28 = { class: "col-md-6 col-lg-3 col-sm-6 mb-3 mb-md-0 mb-lg-0" }
const _hoisted_29 = { class: "card text-white bg-warning shadow-sm" }
const _hoisted_30 = { class: "card-body mx-auto text-center" }
const _hoisted_31 = { class: "icon-dashboard-wrapper bg-light d-flex justify-content-center align-items-center mx-auto" }
const _hoisted_32 = { class: "h5 mt-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, null, -1)
const _hoisted_34 = { class: "col-md-6 col-lg-3 col-sm-6 mb-2 mb-md-0 mb-lg-0" }
const _hoisted_35 = { class: "card text-white bg-danger shadow-sm" }
const _hoisted_36 = { class: "card-body mx-auto text-center" }
const _hoisted_37 = { class: "icon-dashboard-wrapper bg-light d-flex justify-content-center align-items-center mx-auto" }
const _hoisted_38 = { class: "h5 mt-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "card mt-5 mb-2 shadow-sm" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header border-bottom-0 py-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "h5" }, "Leave requests")
  ])
], -1)
const _hoisted_41 = { class: "font-weight-bold text-primary" }
const _hoisted_42 = { class: "d-md-flex text-muted" }
const _hoisted_43 = { class: "mr-md-4" }
const _hoisted_44 = { class: "d-md-flex text-muted" }
const _hoisted_45 = { class: "ml-md-4" }
const _hoisted_46 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_47 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_48 = ["disabled", "onClick"]
const _hoisted_49 = {
  key: 0,
  class: "mr-2 spinner-border spinner-border-sm"
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 1,
  class: "card mb-3 shadow-sm"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "card-body border-0 rounded py-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h6" }, "No Data Available")
], -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "card mt-5 mb-2 shadow-sm" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header border-bottom-0 py-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "h5" }, "People on leaves soon")
  ])
], -1)
const _hoisted_55 = { class: "font-weight-bold text-primary" }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "text-muted" }
const _hoisted_58 = { class: "mr-5" }
const _hoisted_59 = { class: "text-muted" }
const _hoisted_60 = {
  key: 1,
  class: "card mb-3 shadow-sm"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "card-body border-0 rounded py-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h6" }, "No Data Available")
], -1)
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "card mt-5 mb-2 shadow-sm" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header border-bottom-0 py-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "h5" }, "People out today")
  ])
], -1)
const _hoisted_64 = { class: "font-weight-bold text-primary" }
const _hoisted_65 = { class: "text-muted" }
const _hoisted_66 = { class: "mr-5" }
const _hoisted_67 = { class: "text-muted" }
const _hoisted_68 = {
  key: 1,
  class: "card mb-3 shadow-sm"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "card-body border-0 rounded py-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h6" }, "No Data Available")
], -1)
const _hoisted_70 = [
  _hoisted_69
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_profile_image = _resolveComponent("profile-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_card_row = _resolveComponent("card-row")!
  const _component_CancelDialog = _resolveComponent("CancelDialog")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!
  const _component_loading_component = _resolveComponent("loading-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.departmentCount && _ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(" You can add more departments to manage your employees more efficiently. "),
                _createElementVNode("a", {
                  href: "#",
                  class: "text-decoration-none",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({ path: '/admin/departments' })), ["prevent"]))
                }, "Click Here"),
                _hoisted_4
              ]))
            : _createCommentVNode("", true),
          (_ctx.employeeCount && _ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(" Add employees from Employees screen, you can add one by one or bulk upload. They'll receive invitation emails and will setup their own passwords. "),
                _createElementVNode("a", {
                  href: "#",
                  class: "text-decoration-none",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.push({ path: '/admin/employee' })), ["prevent"]))
                }, "Click Here"),
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          (_ctx.adminCount && _ctx.isAdmin && !_ctx.isManager)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createTextVNode(" Looks like you are the only admin, it is highly recommended that once you add employees to your organization and make someone Admin in case you lose access to the portal. "),
                _createElementVNode("a", {
                  href: "#",
                  class: "text-decoration-none",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$router.push({ path: '/admin/employee' })), ["prevent"]))
                }, "Click Here"),
                _hoisted_10
              ]))
            : _createCommentVNode("", true),
          (_ctx.shiftCount && _ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(" Create shift(s) first if you want to start making Roster(s). "),
                _createElementVNode("a", {
                  href: "#",
                  class: "text-decoration-none",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$router.push({ path: '/admin/settings' })), ["prevent"]))
                }, "Click Here"),
                _hoisted_13
              ]))
            : _createCommentVNode("", true),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "icon-dashboard text-info-dark",
                      icon: "calendar-alt"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(this.employeeLeaveRecord.totalLeaves) + " Leaves ", 1),
                  _hoisted_21
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "icon-dashboard text-success-dark",
                      icon: "calendar-alt"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(this.employeeLeaveRecord.leavesAvailed) + " Taken To Date ", 1),
                  _hoisted_27
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "icon-dashboard text-warning-dark",
                      icon: "calendar-alt"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_32, _toDisplayString(this.employeeLeaveRecord.bookAhead) + " Booked Ahead ", 1),
                  _hoisted_33
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "icon-dashboard text-danger-dark",
                      icon: "calendar-alt"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_38, _toDisplayString(this.employeeLeaveRecord.balanceLeaves) + " Remaining ", 1),
                  _hoisted_39
                ])
              ])
            ])
          ]),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _hoisted_40,
                (_ctx.leaveRequests.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.leaveRequests, (item, LRIndex) => {
                      return (_openBlock(), _createBlock(_component_card_row, {
                        key: item.id,
                        actionCol: "3",
                        detailsCol: "8"
                      }, {
                        avatar: _withCtx(() => [
                          _createVNode(_component_profile_image, {
                            "employee-id": item.employeeId,
                            image: _ctx.hasProfileImage(item),
                            mode: "list",
                            gender: item.gender
                          }, null, 8, ["employee-id", "image", "gender"])
                        ]),
                        details: _withCtx(() => [
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(_component_router_link, {
                              class: "nav-link p-0 m-0",
                              to: `/admin/employee/edit/${item.employeeId}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.employeeName), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, _toDisplayString("From: " + _ctx.formateDate(item.startDate)), 1),
                            _createElementVNode("div", null, _toDisplayString("To: " + _ctx.formateDate(item.endDate)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createTextVNode(_toDisplayString("Total Days: " + item.duration) + " ", 1),
                            (item.halfDayType)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString("(Half Day: " + item.halfDayType + ")"), 1)
                                ], 64))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_45, "Leave Reason: " + _toDisplayString(item.reason), 1)
                          ]),
                          (item.comment)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_46, _toDisplayString("Comments: " + item.comment), 1))
                            : _createCommentVNode("", true),
                          (item.isRostered)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                _createElementVNode("small", null, _toDisplayString(item.rosterMessage), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        actions: _withCtx(() => [
                          _createElementVNode("button", {
                            disabled: _ctx.btnLoading == item.id,
                            class: "btn btn-sm btn-success mx-2 px-3 py-1 font-weight-lighter",
                            onClick: _withModifiers(($event: any) => (_ctx.approveLeave(item.id)), ["prevent"])
                          }, [
                            (_ctx.btnLoading == item.id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_49))
                              : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 1,
                                  class: "mr-2",
                                  icon: "check-circle"
                                })),
                            _createTextVNode(" Approve ")
                          ], 8, _hoisted_48),
                          _createElementVNode("a", {
                            class: "btn btn-sm btn-danger mx-2 px-4 py-1 font-weight-lighter",
                            onClick: _withModifiers(($event: any) => (_ctx.cancelLeave(item.id, LRIndex)), ["prevent"])
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              class: "mr-2",
                              icon: "times-circle"
                            }),
                            _createTextVNode(" Reject ")
                          ], 8, _hoisted_50)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_53))
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _hoisted_54,
            (_ctx.upcomingLeaves.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.upcomingLeaves, (item) => {
                  return (_openBlock(), _createBlock(_component_card_row, {
                    key: item.id
                  }, {
                    avatar: _withCtx(() => [
                      _createVNode(_component_profile_image, {
                        "employee-id": item.employeeId,
                        image: _ctx.hasProfileImage(item),
                        mode: "list",
                        gender: item.gender
                      }, null, 8, ["employee-id", "image", "gender"])
                    ]),
                    details: _withCtx(() => [
                      _createElementVNode("div", _hoisted_55, [
                        (_ctx.isAdmin)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              class: "nav-link p-0 m-0",
                              to: `/admin/employee/edit/${item.employeeId}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.employeeName), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(item.employeeName), 1))
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("span", _hoisted_58, _toDisplayString("From: " + _ctx.formateDate(item.startDate)), 1),
                        _createElementVNode("span", null, _toDisplayString("To: " + _ctx.formateDate(item.endDate)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createTextVNode(_toDisplayString("Total Days: " + item.duration) + " ", 1),
                        (item.halfDayType)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString("(Half Day: " + item.halfDayType + ")"), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_60, _hoisted_62))
          ]),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _hoisted_63,
                (_ctx.employeeOnLeaves.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.employeeOnLeaves, (item) => {
                      return (_openBlock(), _createBlock(_component_card_row, {
                        key: item.id
                      }, {
                        avatar: _withCtx(() => [
                          _createVNode(_component_profile_image, {
                            "employee-id": item.employeeId,
                            image: _ctx.hasProfileImage(item),
                            mode: "list",
                            gender: item.gender
                          }, null, 8, ["employee-id", "image", "gender"])
                        ]),
                        details: _withCtx(() => [
                          _createElementVNode("div", _hoisted_64, [
                            _createVNode(_component_router_link, {
                              class: "nav-link p-0 m-0",
                              to: `/admin/employee/edit/${item.employeeId}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.employeeName), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("span", _hoisted_66, _toDisplayString("From: " + _ctx.formateDate(item.startDate)), 1),
                            _createElementVNode("span", null, _toDisplayString("To: " + _ctx.formateDate(item.endDate)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_67, [
                            _createTextVNode(_toDisplayString("Total Days: " + item.duration) + " ", 1),
                            (item.halfDayType)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString("(Half Day: " + item.halfDayType + ")"), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_68, _hoisted_70))
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_CancelDialog, { ref: "CancelDialogue" }, null, 512),
          _createVNode(_component_ConfirmationModal, { ref: "confirmDialogue" }, null, 512)
        ], 64))
      : (_openBlock(), _createBlock(_component_loading_component, { key: 1 }))
  ]))
}